/**
 * @Author：zsj
 * @Date：2022/03/10
 */

const YYYY_MM_DD_HH_MM_SS = 'YYYY-MM-DD HH:mm:ss'
const YYYY_MM_DD = 'YYYY-MM-DD'

// 订单大类
const CATEGORY_TYPE_VALUE = {
    GKLD: 'gkld',
    KFC: 'kfc',
    WAKE_IMG: 'wakeImg',
    SKY_EYE: 'skyEye',
    MI_CAT: 'miCat',
    HAN_CIRCLE: 'hanCircle',
    JG_PDF: 'jgPdf',
    JAN_YIN_SVIP: 'janYinSVip',
    POINT_Z: 'pointZ',
    LE_BO: 'leBo',
    TO_DESK: 'toDesk',
    QUICK_FILM: 'quickFilm',
    SCAN_KING: 'scanKing',
    ASK_REAL: 'askReal',
    ASK_REAL_PC: 'askRealPc',
    ASK_REAL_PC_ZS: 'askRealPcZs',
    BXH: 'bxh',
    BXH_PSW: 'bxhPsw',
    BXH_LH: 'bxhLh',
    YFB: 'yfb',
    SKY_PC: 'skyEyePc',
    VIDEO_TEXT: 'videoText',
    UP_TO_DATE: 'utd',
    JI_ZHEN: 'jiZhen',
};

// 系统操作
const SYSTEM_OPT = {
    EDIT_PHONE: 'editPhone',
    DELETE_PHONE: 'deletePhone',
    ADD_PHONE: 'addPhone',
}

const CATEGORY_TYPE_VALUE_MAP = {
    [CATEGORY_TYPE_VALUE.GKLD]: '公考雷达',
    // [CATEGORY_TYPE_VALUE.MI_CAT]: '秘塔',
    [CATEGORY_TYPE_VALUE.ASK_REAL]: '问真八字',
    [CATEGORY_TYPE_VALUE.ASK_REAL_PC]: '问真PC',
    [CATEGORY_TYPE_VALUE.ASK_REAL_PC_ZS]: '问真PC钻石',
    [CATEGORY_TYPE_VALUE.BXH]: '包小盒',
    [CATEGORY_TYPE_VALUE.BXH_LH]: '包小盒助手',
    // [CATEGORY_TYPE_VALUE.YFB]: '乙方宝',
    [CATEGORY_TYPE_VALUE.SKY_PC]: '天眼查VIP',
    [CATEGORY_TYPE_VALUE.VIDEO_TEXT]: '魔立语音',
    [CATEGORY_TYPE_VALUE.UP_TO_DATE]: 'UpToDate',
    [CATEGORY_TYPE_VALUE.JI_ZHEN]: '吉真紫微',
    [CATEGORY_TYPE_VALUE.POINT_Z]: '点众会员',
    [CATEGORY_TYPE_VALUE.LE_BO]: '乐播',
    [CATEGORY_TYPE_VALUE.TO_DESK]: 'ToDesk',
    [CATEGORY_TYPE_VALUE.QUICK_FILM]: '快影',
    [CATEGORY_TYPE_VALUE.BXH_PSW]: '包小盒账密',
    // [CATEGORY_TYPE_VALUE.HAN_CIRCLE]: '韩小圈',
    [CATEGORY_TYPE_VALUE.SCAN_KING]: '扫描王',
    [CATEGORY_TYPE_VALUE.JG_PDF]: '极光pdf',
    [CATEGORY_TYPE_VALUE.JAN_YIN_SVIP]: '剪映SVIP',
    [CATEGORY_TYPE_VALUE.POINT_Z]: '点众会员',
    [CATEGORY_TYPE_VALUE.SKY_EYE]: '天眼查',
    [CATEGORY_TYPE_VALUE.WAKE_IMG]: '醒图',
    [CATEGORY_TYPE_VALUE.KFC]: '肯德基',
};

const KFC_SUB_TYPE_VALUE = {
    BREAKFAST: 'breakfast',
    DELIVERY: 'delivery',
    AFTERNOON: 'afternoon',
}

const KFC_SUB_TYPE_VALUE_MAP = {
    [KFC_SUB_TYPE_VALUE.BREAKFAST]: '早餐',
    [KFC_SUB_TYPE_VALUE.DELIVERY]: '外送',
    [KFC_SUB_TYPE_VALUE.AFTERNOON]: '下午茶',
}

const ORDER_FROM_VALUE = {
    TB: 'tb',
    PDD: 'pdd'
}
const ORDER_FROM_VALUE_MAP = {
    [ORDER_FROM_VALUE.TB]: '淘宝',
    [ORDER_FROM_VALUE.PDD]: '拼多多',
}

module.exports = {
    remUnit: 16,
    remPrecision: 5,
    designWidth: 375,
    YYYY_MM_DD_HH_MM_SS,
    YYYY_MM_DD,
    CATEGORY_TYPE_VALUE,
    CATEGORY_TYPE_VALUE_MAP,
    KFC_SUB_TYPE_VALUE,
    KFC_SUB_TYPE_VALUE_MAP,
    SYSTEM_OPT,
    ORDER_FROM_VALUE_MAP,
    ORDER_FROM_VALUE,
}
